export const chatsData = [
    {
        id: 1,
        chatInfo: {
            chatName: "Chat name 1",
            no_users: 0
        },
        usersList: []
    },
    {
        id: 2,
        chatInfo: {
            chatName: "Chat name 2",
            no_users: 2
        },
        usersList: ["User name 1", "User name 2"]
    },
    {
        id: 3,
        chatInfo: {
            chatName: "Chat name 3",
            no_users: 2
        },
        usersList: ["User name 1", "User name 2"]
    },
    {
        id: 4,
        chatInfo: {
            chatName: "Chat name 4",
            no_users: 2
        },
        usersList: ["User name 1", "User name 2"]
    },
]